// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginLayoutHeader__container-c36b49 {
  color: var(--base-110);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
  margin-bottom: 8px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/layouts/LoginLayout/LoginLayoutHeader/LoginLayoutHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  color: var(--base-110);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n  margin-bottom: 8px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoginLayoutHeader__container-c36b49`
};
module.exports = ___CSS_LOADER_EXPORT___;
